<template>
   <v-toolbar app dark fixed clipped-left clipped-right elevate-on-scroll color="#1c1d29">
    <!-- <v-toolbar-side-icon @click.stop="toggleDrawer" class="hidden-sm-and-up"></v-toolbar-side-icon> -->
      <img src="/img/adgen-logo.png" class="site-logo hidden-md-and-down" />
      <img src="/img/adgen-small.png" class="site-logo hidden-lg-and-up" />

    <v-spacer></v-spacer>
    <!-- <v-btn flat depressed color="#fff" router-link to="/">
      <img src="/images/v2/logo-frontend.jpg" class="site-logo" />
    </v-btn> -->

    <v-toolbar-items>
      <!-- <v-btn flat  router-link to="/live">Live</v-btn> -->
      <v-btn flat router-link to="/breakouts">Breakouts</v-btn>
    </v-toolbar-items>



    <!-- <v-toolbar-title class="mr-5">MC images</v-toolbar-title> -->
      <!-- <v-autocomplete
        v-model="model"
        :items="items"
        :loading="isLoading"
        :search-input.sync="search"
        chips
        clearable
        hide-details
        hide-selected
        item-text="name"
        item-value="symbol"
        prepend-inner-icon="search"
        label="Search"
        solo-inverted
        flat
        class="hidden-sm-and-down"
    >
      <template v-slot:no-data>
        <v-list-tile>
          <v-list-tile-title>
            Type to search
          </v-list-tile-title>
        </v-list-tile>
      </template>
      <template v-slot:selection="{ item, selected }">
        <v-chip
          :selected="selected"
          color="blue-grey"
          class="white--text">
          <v-icon left>mdi-coin</v-icon>
          <span v-text="item.name"></span>
        </v-chip>
      </template>
      <template v-slot:item="{ item }">
        <v-list-tile-avatar
          color="indigo"
          class="headline font-weight-light white--text"
        >
          @{{ item.name.charAt(0) }}
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title v-text="item.name"></v-list-tile-title>
          <v-list-tile-sub-title v-text="item.symbol"></v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-icon>mdi-coin</v-icon>
        </v-list-tile-action>
      </template>
    </v-autocomplete> -->
    <v-spacer></v-spacer>




    
     <v-toolbar-items>
  

      

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
           <v-btn icon flat href="https://sglogin.com/thegatechurch/hostedpage-d646c9a44299b0bc5294e6524734a79a.html" target="_blank" v-on="on">
         <v-icon>favorite</v-icon>
       </v-btn>
        </template>
        <span>Give</span>
      </v-tooltip>
       
       <v-menu offset-y bottom left v-if="currentUser">
           <template v-slot:activator="{ on }">
              <v-toolbar-side-icon icon large v-on="on">
                  <v-avatar size="32px" color="grey" class="white--text">
                  {{currentUser.initials}}
                  </v-avatar>
              </v-toolbar-side-icon> 
          </template>

      <v-card>

         <v-list>
   

              <v-list-tile>
                  <v-list-tile-content>
                            <v-list-tile-title>{{currentUser.name}}</v-list-tile-title>
                    </v-list-tile-content>

              </v-list-tile>

             
            </v-list>
            
            <v-divider></v-divider>

          <v-list dense>

                <v-list-tile href="/logout">
                  <v-list-tile-title>Logout</v-list-tile-title>
                </v-list-tile>
            </v-list>

                  </v-card>

          </v-menu>
       
        
    </v-toolbar-items>
</v-toolbar>
</template>

<script>

import { mapState } from 'vuex';

    export default {
        props: [],
        data(){  
            return {
              currentUser: Spark.state.user
            }
        },
        created(){

         },
        mounted() {
          //  console.log('Toolbar mounted.')
        },
        computed: {
          //  ...mapState(['isLoggedIn', 'currentUser']),
        },
        methods: {
            toggleDrawer(){
                this.$store.dispatch('toggleDrawer');
            }
 
        }
    }
</script>

<style lang="scss" scoped>

.site-logo {

  height: 30px;

  @media screen and (max-width: 768px) {
      height: 29px;
  } 


}

.v-list__tile__action {
    min-width: 35px;
}

.v-icon {
    color: #8edfb4;
}

</style>